export const DATE_TIME_FORMAT = "dd.MM.yyyy HH:mm:ss";
